module.exports = __webpack_public_path__ + "static/media/global 2.0c000cd9.svg";